import {Routes, Route} from 'react-router-dom';
import './App.css';

import { AuthProvider } from "./context/Services/Auth";
import { GlobalProvider } from "./context/GlobalContext";
import PrivateRoute from "./context/Routes/PrivateRoute";
import Home from './Pages/Home/Home';
import Login from './Pages/Login/Login';
import "@fontsource/public-sans"; 

function App() {
  return (
    <main className="app flex flex-col gap" style={{ fontFamily: `"Public Sans", sans-serif, -apple-system, blinkmacsystemfont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"` }}>
      <GlobalProvider>
        <AuthProvider>
          <Routes> 
              <Route path="/*" element={<PrivateRoute> <Home/> </PrivateRoute>}/>
              <Route path="/Login" element={<Login/>}/>
          </Routes>
        </AuthProvider>
      </GlobalProvider>
    </main>
  );
}

export default App;
